import { jsx } from 'react/jsx-runtime';

// src/internal/link/defaultLinkComponent.tsx
var defaultLinkComponent = ({
  to,
  children,
  ...rest
}) => /* @__PURE__ */ jsx("a", { href: to, ...rest, children });

export { defaultLinkComponent };
//# sourceMappingURL=chunk-46OQMWYR.js.map
//# sourceMappingURL=chunk-46OQMWYR.js.map